import FormRegisterUserApi from '@/api/form-register-user'

const initialState = () => ({
  infos: null,
  selectedMonth: null
})

export const FormRegisterUser = {
  namespaced: true,
  state: initialState,
  getters: {
    infos: state => state.infos,
    selectedMonth: state => state.selectedMonth
  },
  mutations: {
    RESET_STATE (state) {
      const initial = initialState()
      Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
    SET_INFOS (state, item) {
      state.infos = item
    },
    SET_SELECTED_MONTH (state, item) {
      state.selectedMonth = item
    }
  },
  actions: {
    getFormRegisterUser: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        FormRegisterUserApi.getRegisterInfo(payload)
          .then((response) => {
            if (response && response.title && response.message) {
              reject(response)
            } else {
              let infos = response.data.data.register_data.forms
              commit('SET_INFOS', infos)
              resolve()
            }
          })
      })
    },
    actionSetSelectedMonth: ({ commit }, payload) => {
      commit('SET_SELECTED_MONTH', payload)
    }
  }
}
